import { render } from "./CloneBtn.vue?vue&type=template&id=e3798764&scoped=true"
import script from "./CloneBtn.vue?vue&type=script&lang=js"
export * from "./CloneBtn.vue?vue&type=script&lang=js"

import "./CloneBtn.vue?vue&type=style&index=0&id=e3798764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3798764"]])

export default __exports__